import EventEmitter from 'events';
import { useEffect } from 'react';
var RNEvents = new EventEmitter();
export var registerRNHandler = function (action, callback) {
    try {
        RNEvents.on(action, callback);
        return function () { return RNEvents.off(action, callback); };
    }
    catch (e) {
        console.error('Error registering RN handler:', e);
    }
};
export var useRNHandler = function (action, callback) {
    useEffect(function () {
        try {
            var deregister_1 = registerRNHandler(action, callback);
            return function () {
                deregister_1();
            };
        }
        catch (error) {
            console.error('Error using RN handler:', error);
        }
    }, [action, callback]);
};
var onMessageFromRN = function (message) {
    try {
        var _a = JSON.parse(message), action = _a.action, payload = _a.payload;
        RNEvents.emit(action, payload);
    }
    catch (e) {
        console.error('Error parsing message from RN:', e);
    }
};
export var sendMessageToRN = function (message) {
    var _a;
    try {
        (_a = window === null || window === void 0 ? void 0 : window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify(message));
    }
    catch (error) {
        console.error('Error sending message to RN:', error);
    }
};
export default function useListenFromRn() {
    useEffect(function () {
        try {
            window.onMessageFromRN = onMessageFromRN;
        }
        catch (e) {
            console.error('Error attaching onMessageFromRN:', e);
        }
    }, []);
    return {
        sendMessageToRN: sendMessageToRN,
        useRNHandler: useRNHandler,
        registerRNHandler: registerRNHandler,
    };
}
// Attach the handler to `window` so we can access it from
// scripts injected by React Native WebView.
